module.exports = __webpack_public_path__ + "img/02082008000170.e568ef0a.png";